'use client'
import { adBlockerDetected } from '@/src/lib/utils'
import {
    Box,
    Text,
    Image,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Flex,
    Button,
    useDisclosure,
    useBreakpointValue,
} from '@chakra-ui/react'
import { useEffect } from 'react'

export default function AdBlockerPopup({ index, fixed }: { index?: number, fixed?: boolean }) {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const isMobile = useBreakpointValue({ base: true, sm: false })

    useEffect(() => {
        adBlockerDetected().then((isBlocked) => {
            if (isBlocked) {
                console.log("ADSBLOCKER ON")
                onOpen()
            } else {
                onClose()
                console.log("ADSBLOCKER OFF")
            }
          });
    
    }, [])
    return (
        <Modal isOpen={isOpen} onClose={onClose} size={'md'} isCentered motionPreset="slideInBottom" closeOnOverlayClick={false}>
            <ModalOverlay />
            {
                isMobile ?
                    <ModalContent
                        borderTopRadius={28}
                        position="fixed"
                        bottom="0"
                        margin="0 auto"
                        width="100%"
                        maxWidth="600px"
                        display={{ base: 'block', sm: 'none' }}
                    >
                        <ModalHeader>Ad Blocker Detected!</ModalHeader>
                        {!fixed && <ModalCloseButton />}
                        <hr />
                        <ModalBody mt={2}>
                            <Box mb={5} display={'flex'} justifyContent={'center'}>
                                <Image
                                    boxSize="75px"
                                    src={'/adBlocker/alert.svg'}
                                    alt="wallet"
                                />
                            </Box>
                            <Text
                                mb={6}
                                textAlign={'center'}
                                fontWeight={600}
                                fontSize={20}
                            >
                                Disable your <Text display={'inline-flex'} color={'#ED837F'}>ad blocker</Text> and refresh to enjoy uninterrupted videos.
                            </Text>
                            {!fixed && <Box mb={4}>
                                <Button
                                    className="w-full py-2 font-medium text-[#656565]"
                                    bg={'lyk-red!important'}
                                    color={'white'}
                                    onClick={onClose}
                                >
                                    Got it
                                </Button>
                            </Box>}
                        </ModalBody>
                    </ModalContent>
                    :
                    <ModalContent color={'#3e3e3e'}>
                        <ModalHeader>Ad Blocker Detected!</ModalHeader>
                        {!fixed && <ModalCloseButton />}
                        <hr />
                        <ModalBody mt={2}>
                            <Box mb={5} display={'flex'} justifyContent={'center'}>
                                <Image
                                    boxSize="75px"
                                    src={'/adBlocker/alert.svg'}
                                    alt="wallet"
                                />
                            </Box>
                            <Text
                                mb={6}
                                textAlign={'center'}
                                fontWeight={600}
                                fontSize={20}
                            >
                                Please uninstall <Text display={'inline-flex'} color={'#ED837F'}>ad blocker</Text> to enjoy uninterrupted content on our platform.
                            </Text>
                        </ModalBody>
                    </ModalContent>
            }
        </Modal>
    )
}
